// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".leftTabBase{width:130px;max-width:500px;height:100%;top:50px;left:0;background:#fff;border-right:1px solid #ccc}", ""]);
// Exports
module.exports = exports;
